export default {
	installationCost: {
		studio: 115_000,
		onebed: 120_000,
		twobed: 125_000,
		xl8: 155_000,
		xl10: 160_000
	},
	deliveryCost: {
		studio: 12_000,
		onebed: 14_000,
		twobed: 14_000,
		xl8: 26_000,
		xl10: 32_000
	},
	options: [
		{
			key: "region",
			values: [
				{
					key: "socal",
					display: {
						title: "Southern California",
						alternativeTitle: "Southern<br>California",
						sf_field: "GEO_c",
						sf_value: "Southern California"
					}
				},
				{
					key: "nocal",
					display: {
						title: "San&nbsp;Francisco Bay&nbsp;Area",
						alternativeTitle: "San&nbsp;Francisco<br>Bay&nbsp;Area",
						sf_field: "GEO_c",
						sf_value: "San Francisco Bay Area"
					}
				},
				{
					key: "rest",
					display: {
						title: "Somewhere else",
						subtitle: "Coming soon",
						sf_field: "GEO_c",
						sf_value: "Other"
					}
				}
			],
			display: {
				label: "Region",
				title: "Where is your Backyard going?"
			}
		},
		{
			key: "layout",
			sf_field: "Unit_Layout__c",
			values: [
				{
					key: "studio",
					sf_value: "Studio",
					cost: 152_000,
					display: {
						title: "Studio",
						subtitle: "420 gross sq. ft.",
						primarySubtitle: "1 bath"
					}
				},
				{
					key: "onebed",
					sf_value: "One Bedroom",
					cost: 170_000,
					display: {
						title: "One bedroom",
						subtitle: "540 gross sq. ft.",
						primarySubtitle: "1 bedroom, 1 bath"
					}
				},
				{
					key: "twobed",
					sf_value: "Two Bedroom",
					cost: 190_000,
					display: {
						title: "Two bedroom",
						subtitle: "690 gross sq. ft.",
						primarySubtitle: "2 bedrooms, 1 bath"
					}
				},
				{
					key: "xl8",
					sf_value: "XL 8",
					cost: 249_000,
					display: {
						title: "Backyard XL 8",
						subtitle: "800 gross sq. ft.",
						primarySubtitle: "2 bedrooms, 2 baths"
					}
				},
				{
					key: "xl10",
					sf_value: "XL 10",
					cost: 277_000,
					display: {
						title: "Backyard XL 10",
						subtitle: "950 gross sq. ft.",
						primarySubtitle: "2 bedrooms, 2 baths"
					}
				}
			],
			display: {
				label: "Layout",
				title: "Choose your layout"
			}
		},
		{
			key: "cladding",
			sf_field: "Base_Material__c",
			values: [
				{
					key: "cement",
					sf_value: "Fiber Cement - Vertical",
					display: {
						title: "Fiber cement",
						subtitle: "Durable and weather resistant",
						list: [
							'Vertical 7" panels with V-groove',
							"Five standard colors or custom color",
							"Fire-, moisture-, and rot-resistant"
						]
					}
				},
				{
					key: "metal",
					sf_value: "Insulated Metal Panel",
					cost: ({ layout }) =>
						({
							studio: 23500,
							onebed: 27500,
							twobed: 32000,
							xl8: 45000,
							xl10: 50000
						})[layout],
					display: {
						title: "Smooth-coated steel",
						subtitle: "Lustrous and maintenance-free",
						list: [
							'Horizontal 24" smooth-coated steel insulated panels',
							"Three standard colors plus two premium colors",
							"Easy to clean and never needs to be painted",
							"Fire-, moisture-, and rot-resistant"
						]
					}
				}
			],
			display: {
				label: "Exterior material",
				title: "Choose your cladding material"
			}
		},
		{
			key: "color",
			sf_field: "Base_Color_Selection__c",
			values: [
				{
					key: "base-bonewhite",
					sf_value: "Bone White",
					display: {
						title: "Bone white",
						description: "A warm and simple white. Classic."
					}
				},
				{
					key: "base-driftwood",
					sf_value: "Driftwood",
					display: {
						title: "Driftwood",
						description:
							"A flexible and serene gray with cool undertones."
					}
				},
				{
					key: "base-parchment",
					sf_value: "Parchment",
					display: {
						title: "Parchment",
						description: "An inviting, earthy beige. Like stucco."
					}
				},
				{
					key: "base-evergreen",
					sf_value: "Evergreen",
					cost: ({ cladding }) =>
						({ cement: 0, metal: 5000 })[cladding],
					display: {
						title: "Evergreen",
						description:
							"A deep and vibrant green with a hint of earthiness."
					}
				},
				{
					key: "base-dark-bronze",
					sf_value: "Dark Bronze",
					cost: ({ cladding }) =>
						({ cement: 0, metal: 5000 })[cladding],
					display: {
						title: "Dark bronze",
						description: "Rich and warm. Most definitely not black."
					}
				},
				{
					key: "custom",
					sf_value: "Custom (Fiber Cement Only)",
					cost: ({ layout }) =>
						layout?.startsWith("xl") ? 4000 : 3000,
					conditions: {
						cladding: (cladding) => cladding === "cement"
					},
					display: {
						title: "Custom color",
						subtitle: "Not shown and specified later"
					}
				}
			],
			display: {
				label: "Cladding color",
				title: "Choose your cladding color"
			}
		},
		{
			key: "roof",
			sf_field: "Roof_Color__c",
			values: [
				{
					key: "roof-dark-bronze",
					sf_value: "Dark Bronze",
					display: {
						title: "Dark bronze",
						description: "Extremely versatile, deep and muted."
					}
				},
				{
					key: "roof-metallic-silver",
					sf_value: "Silver",
					cost: 2500,
					display: {
						title: "Metallic silver",
						description: "Slightly warm with a subtle fleck."
					}
				}
			],
			display: {
				label: "Roof",
				title: "Choose your roof color"
			}
		},
		{
			key: "floor",
			sf_field: "Floor_Option__c",
			values: [
				{
					key: "floor-natural-oak",
					sf_value: "Natural oak",
					display: {
						title: "Natural oak",
						description:
							"Waterproof stone composite flooring with a warm, honest character and visible grain."
					}
				},
				{
					key: "floor-dark-oak",
					sf_value: "Dark oak",
					cost: 1000,
					display: {
						title: "Dark oak",
						description:
							"Waterproof stone composite flooring with a rich depth that anchors the space."
					}
				}
			],
			display: {
				label: "Flooring",
				title: "Choose your floor color"
			}
		},
		{
			key: "kitchen-cabinet-finish",
			sf_field: "Kitchen_Cabinet_Finish__c",
			values: [
				{
					key: "kitchen-cabinet-bone-white",
					sf_value: "Bone white",
					display: {
						title: "Bone white",
						description: "Clean and unobtrusive. Emphasizes depth."
					}
				},
				{
					key: "kitchen-cabinet-natural-oak",
					sf_value: "Natural oak",
					cost: 5000,
					display: {
						title: "Natural oak",
						description:
							"Brings tactile warmth. Intentionally unfussy."
					}
				}
			],
			display: {
				label: "Kitchen cabinet finish",
				title: "Choose your kitchen cabinet finish"
			}
		},
		{
			key: "entry",
			sf_field: "Studio_Entry__c",
			conditions: {
				layout: (layout) => layout === "studio"
			},
			values: [
				{
					key: "entry-side",
					sf_value: "Side Entry",
					display: {
						title: "Side entry",
						summaryLabel: "Side entry",
						subtitle: "Enter through the hallway"
					}
				},
				{
					key: "entry-front",
					sf_value: "Front Entry",
					cost: 3000,
					display: {
						title: "Front entry",
						summaryLabel: "Front entry",
						subtitle: "Enter directly into the living area"
					}
				}
			],
			display: {
				label: "Entry",
				title: "Choose your entrance location",
				camera: "right-angle"
			}
		},
		{
			key: "front",
			sf_field: "Front_Option__c",
			conditions: {
				entry: (entry) => entry === undefined || entry === "entry-side"
			},
			values: [
				{
					key: "front-window",
					sf_value: "Casement Window",
					display: {
						title: "Casement window",
						summaryLabel: "Front casement window",
						subtitle: "3'&thinsp;×&thinsp;5'"
					}
				},
				{
					key: "front-doors",
					sf_value: "Double Doors",
					cost: 7000,
					installationCost: 4000,
					display: {
						title: "Double doors",
						summaryLabel: "Front double doors",
						subtitle:
							"<nobr>3'&thinsp;×&thinsp;6'8\"</nobr> glass doors"
					}
				}
			],
			display: {
				label: "Front",
				title: "Choose your front window&nbsp;or&nbsp;doors",
				camera: "right-angle"
			}
		},
		{
			key: "left",
			sf_field: "Side_Option__c",
			conditions: {
				layout: (layout) => layout?.startsWith("xl") === false
			},
			values: [
				{
					key: "side-window",
					sf_value: "Casement Window",
					display: {
						title: "Casement Window",
						summaryLabel: "Left side casement window",
						subtitle: "3'&thinsp;×&thinsp;5'"
					}
				},
				{
					key: "side-doors",
					sf_value: "Double Doors",
					cost: 7000,
					installationCost: 4000,
					display: {
						title: "Double doors",
						summaryLabel: "Left side double doors",
						subtitle:
							"<nobr>3'&thinsp;×&thinsp;6'8\"</nobr> glass doors"
					}
				}
			],
			display: {
				label: "Left side",
				title: ({ layout }) =>
					layout === "twobed"
						? "Choose your secondary bedroom window&nbsp;or&nbsp;doors"
						: "Choose your living room window&nbsp;or&nbsp;doors",
				camera: "left-angle"
			}
		},
		{
			key: "xl-living-room-side",
			sf_field: "Side_Option__c",
			conditions: {
				layout: (layout) => layout?.startsWith("xl") === true
			},
			values: [
				{
					key: "window",
					sf_value: "Casement Window",
					display: {
						title: "Casement window",
						summaryLabel: "Living room casement window",
						subtitle: "3'&thinsp;×&thinsp;5'"
					}
				},
				{
					key: "doors",
					sf_value: "Double Doors",
					cost: 7000,
					installationCost: 4000,
					display: {
						title: "Double doors",
						summaryLabel: "Living room double doors",
						subtitle:
							"<nobr>3'&thinsp;×&thinsp;6'8\"</nobr> glass doors"
					}
				}
			],
			display: {
				label: "Living room side",
				title: "Choose your living room window&nbsp;or&nbsp;doors",
				camera: "right-angle"
			}
		},
		{
			key: "xl-primary-bedroom-side",
			sf_field: "Primary_Bedroom_Option__c",
			conditions: {
				layout: (layout) => layout?.startsWith("xl") === true
			},
			values: [
				{
					key: "window",
					sf_value: "Casement Window",
					display: {
						title: "Casement window",
						summaryLabel: "Primary bedroom casement window",
						subtitle: "3'&thinsp;×&thinsp;5'"
					}
				},
				{
					key: "doors",
					sf_value: "Double Doors",
					cost: 7000,
					installationCost: 4000,
					display: {
						title: "Double doors",
						summaryLabel: "Primary bedroom double doors",
						subtitle:
							"<nobr>3'&thinsp;×&thinsp;6'8\"</nobr> glass doors"
					}
				}
			],
			display: {
				label: "Primary bedroom room side",
				title: "Choose your primary bedroom window&nbsp;or&nbsp;doors",
				camera: ({ layout }) =>
					layout === "xl8" ? "left-angle" : "right-angle-back"
			}
		},
		{
			key: "xl-secondary-bedroom-side",
			sf_field: "Secondary_Bedroom_Option__c",
			conditions: {
				layout: (layout) => layout?.startsWith("xl")
			},
			values: [
				{
					key: "window",
					sf_value: "Casement Window",
					display: {
						title: "Casement window",
						summaryLabel: "Secondary bedroom casement window",
						subtitle: "3'&thinsp;×&thinsp;5'"
					}
				},
				{
					key: "doors",
					sf_value: "Double Doors",
					cost: 7000,
					installationCost: 4000,
					display: {
						title: "Double doors",
						summaryLabel: "Secondary bedroom double doors",
						subtitle:
							"<nobr>3'&thinsp;×&thinsp;6'8\"</nobr> glass doors"
					}
				}
			],
			display: {
				label: "Secondary bedroom room side",
				title: "Choose your secondary bedroom window&nbsp;or&nbsp;doors",
				camera: ({ layout }) =>
					layout === "xl8" ? "right-angle" : "right-angle-back"
			}
		},
		{
			key: "solar",
			sf_field: "Solar_Option__c",
			values: [
				{
					key: "solar-no",
					sf_value: "No Solar",
					display: {
						title: "No solar",
						summaryLabel: "None",
						subtitle: "Power with the grid",
						description: "No solar"
					}
				},
				{
					key: "solar-half",
					sf_value: "Half Solar",
					cost: ({ layout }) =>
						({
							studio: 8100,
							onebed: 10200,
							twobed: 13500,
							xl8: 8100,
							xl10: 10200
						})[layout],
					display: {
						title: ({ layout }) =>
							layout?.startsWith("xl")
								? "Half solar array"
								: "Solar array",
						subtitle: ({ layout }) =>
							layout?.startsWith("xl")
								? "Offset your energy usage"
								: "Go net zero&thinsp;¹",
						summaryLabel: "Half solar array",
						description: ({ layout }) =>
							layout === "studio"
								? "7-panel, 2.5 kW DC photovoltaic system"
								: layout === "onebed"
									? "9-panel, 3.4 kW DC photovoltaic system"
									: "12-panel, 4.5 kW DC photovoltaic system"
					}
				},
				{
					key: "solar-full",
					sf_value: "Full Solar",
					cost: ({ layout }) =>
						({
							studio: 16200,
							onebed: 20400,
							twobed: 27000,
							xl8: 16200,
							xl10: 20400
						})[layout],
					conditions: {
						layout: (layout) => layout?.startsWith("xl")
					},
					display: {
						title: "Full solar array",
						subtitle: ({ layout }) =>
							layout?.startsWith("xl")
								? "Go net zero&thinsp;¹"
								: "Offset even more energy usage",
						summaryLabel: "Full solar array",
						description: ({ layout }) =>
							layout === "studio"
								? "14-panel, 5.3 kW DC photovoltaic system"
								: layout === "onebed"
									? "18-panel, 6.8 kW DC photovoltaic system"
									: "24-panel, 9.1 kW DC photovoltaic system"
					}
				}
			],
			display: {
				label: "Solar",
				title: "Add solar panels",
				camera: "roof"
			}
		},
		{
			key: "powerwall",
			sf_field: "Powerwall__c",
			conditions: {
				solar: (value) => value !== "solar-no"
			},
			values: [
				{
					key: "standard",
					sf_value: "Standard",
					display: {
						title: "Standard"
					}
				},
				{
					key: "powerwall",
					sf_value: "Tesla Powerwall 3",
					cost: 16500,
					display: {
						title: "Tesla Powerwall 3",
						subtitle: (c) =>
							c["solar"] === "solar-no"
								? "Available with solar array"
								: "Use your clean energy 24/7"
					}
				}
			],
			display: {
				label: "Tesla Powerwall 3",
				title: "Tesla Powerwall 3",
				camera: ({ layout }) =>
					layout === "xl10" ? "left-back" : "left-angle-back"
			}
		},
		{
			key: "kitchen-layout",
			sf_field: "Kitchen_Layout__c",
			conditions: {
				layout: (layout) => layout === "xl10"
			},
			values: [
				{
					key: "standard",
					sf_value: "Standard",
					display: {
						title: "Standard kitchen layout",
						subtitle: "Bring your own dining table"
					}
				},
				{
					key: "island",
					sf_value: "Kitchen island",
					cost: 5000,
					display: {
						title: "Kitchen with island",
						subtitle: "Add counter and storage space"
					}
				}
			],
			display: {
				label: "Kitchen layout",
				title: "Choose your kitchen layout"
			}
		},
		{
			key: "kitchen-cooler",
			sf_field: "Kitchen_Cooler__c",
			conditions: {
				"layout": (value) => value === "xl10",
				"kitchen-layout": (value) => value === "island"
			},
			values: [
				{
					key: "standard",
					sf_value: "Standard"
				},
				{
					key: "island",
					sf_value: "Wine and beverage cooler",
					cost: 2500,
					display: {
						title: "Wine and beverage cooler",
						subtitle: (c) =>
							c["kitchen-layout"] === "island"
								? "Chill your Barolo perfectly"
								: "Available with kitchen island"
					}
				}
			],
			display: {
				title: "Wine and beverage cooler",
				label: "Wine and beverage cooler"
			}
		},
		{
			key: "primary-bedroom-wardrobe",
			sf_field: "Primary_Bedroom_Wardrobe__c",
			conditions: {
				layout: (layout) => layout === "onebed" || layout === "twobed"
			},
			values: [
				{
					key: "standard",
					sf_value: "Standard",
					display: {
						title: "Standard wardrobe"
					}
				},
				{
					key: "full",
					sf_value: "Full Width",
					cost: 1750,
					display: {
						title: "Full-width wardrobe",
						summaryLabel: "Primary bedroom full wardrobe",
						subtitle: "Spans the entire wall"
					}
				}
			],
			display: {
				title: "Choose storage for this bedroom"
			}
		},
		{
			key: "secondary-bedroom-wardrobe",
			sf_field: "Secondary_Bedroom_Wardrobe__c",
			conditions: {
				layout: (layout) => layout === "twobed"
			},
			values: [
				{
					key: "standard",
					sf_value: "Standard",
					display: {
						title: "Standard wardrobe"
					}
				},
				{
					key: "full",
					sf_value: "Full Width",
					cost: 1750,
					display: {
						title: "Full-width wardrobe",
						summaryLabel: "Secondary bedroom full wardrobe",
						subtitle: "Spans the entire wall"
					}
				}
			],
			display: {
				title: "Choose storage for this bedroom"
			}
		},
		{
			key: "bathroom-accessibility-kit",
			sf_field: "Bathroom_Accessibility_Kit__c",
			values: [
				{
					key: "standard",
					sf_value: "Standard",
					display: {
						title: "Standard"
					}
				},
				{
					key: "bathroom-accessibility-kit",
					sf_value: "Bathroom accessibility kit",
					display: {
						title: "Bathroom accessibility kit",
						subtitle: "Enhance safety and ease of use",
						cost: "Free"
					}
				}
			],
			display: {
				title: "Bathroom accessibility kit"
			}
		},
		{
			key: "interior-blinds",
			sf_field: "Blinds__c",
			values: [
				{
					key: "standard",
					sf_value: "No blinds",
					display: {
						title: "Standard"
					}
				},
				{
					key: "blinds-roller",
					sf_value: "Rolling blinds",
					installationCost: (c) =>
						({
							studio: 1500,
							onebed: 1750,
							twobed: 2000,
							xl8: 2250,
							xl10: 2500
						})[c.layout] +
						(c.left === "side-doors" ? 300 : 0) +
						(c.entry === "entry-front" || c.front === "front-doors"
							? 300
							: 0) +
						(c["xl-living-room-side"] === "doors" ? 300 : 0) +
						(c["xl-primary-bedroom-side"] === "doors" ? 300 : 0) +
						(c["xl-secondary-bedroom-side"] === "doors" ? 300 : 0),
					display: {
						title: "Roller blinds",
						subtitle: "More privacy without losing light"
					}
				}
			],
			display: {
				title: "Blinds"
			}
		}
	]
};
